import React from 'react'
import { DepartmentDetailedReviewsComponent } from '#src/generated/graphql'
import PageContent from '#src/components/PageContent'
import times from 'lodash/times'
import Slider from './Slider'
import ReviewCard from './ReviewCard'
import StarIcon from './star-rate.svg'
import styles from './styles.css'

interface ReviewsProps {
  departmentId: string
}

const Reviews: React.SFC<ReviewsProps> = ({ departmentId }) => {
  return (
    <DepartmentDetailedReviewsComponent
      variables={{
        departmentId
      }}
    >
      {({ data }) => {
        if (
          data &&
          data.department &&
          data.department.consumerExpertReviewConnection.edges.length > 0
        ) {
          const department = data.department
          /**
           * Only render this module if we have four reviews over four stars, the review
           * has comments and and the comments are over 40 characters long
           */
          const qualityReviews = department.consumerExpertReviewConnection.edges.filter(
            reviewNode => {
              return (
                reviewNode.node.rating > 1 &&
                reviewNode.node.comments !== null &&
                reviewNode.node.comments !== undefined &&
                reviewNode.node.comments.length > 40
              )
            }
          )

          const averageRating = department.reviewSummary.averageRating
            ? department.reviewSummary.averageRating
            : undefined

          /**
           * We need at least three to properly render this module
           */
          if (qualityReviews.length > 3) {
            return (
              <div className={styles.background}>
                <PageContent>
                  <div className={styles.reviews}>
                    <div className={styles.header}>
                      <div className={styles.headerText}>Recent reviews from the community</div>
                      {averageRating &&
                        averageRating > 4 && (
                          <div className={styles.rating}>
                            {averageRating.toFixed(1)}
                            <div className={styles.ratingStarSet}>
                              {times(Math.round(averageRating), index => (
                                <StarIcon key={index} className={styles.ratingStar} />
                              ))}
                            </div>
                          </div>
                        )}
                    </div>

                    <Slider>
                      {qualityReviews.map(reviewNode => {
                        const review = reviewNode.node

                        return (
                          <ReviewCard
                            key={review.id}
                            review={review}
                            departmentSlug={department.slug}
                          />
                        )
                      })}
                    </Slider>
                  </div>
                </PageContent>
              </div>
            )
          }
        }

        return null
      }}
    </DepartmentDetailedReviewsComponent>
  )
}

export default Reviews
